import { Controller } from "stimulus";
import { rebind } from "../rebind";
import { railsAjax } from "../../services/rails-ajax";

export default class extends Controller {
  //
  // life cycle
  //
  initialize() {
    this.hidePager();
  }

  //
  // target
  //
  static targets = [
    'append',
    'more',
    'pager'
  ]
  get data() {
    const dataArray = $('div[data-target="blog--page"]');
    const data = $(dataArray[dataArray.length - 1]);
    return {
      offset: data.data('offset'),
      isMore: data.data('is-more'),
      category: data.data('category'),
      tag: data.data('tag')
    };
  }
  // public
  more() {
    this.apiIndexBlogs();
  }

  hidePager() {
    $(this.pagerTarget).addClass('hidden');
  }

  // private
  apiIndexBlogs() {
    const category = this.data.category;
    const tag = this.data.tag;
    const offset = this.data.offset;
    railsAjax({
      type: "GET",
      url: `/blogs/?category=${category}&tag=${tag}&offset=${offset}`,
      done: (response) => {
        $(this.appendTarget).append(response);
        rebind(this.appendTarget);
        if (!this.data.isMore) {
          $(this.moreTarget).addClass('hidden');
        }
      }
    });
  }
};

